import OfferIcon from 'src/assets/svgExports/OfferIcon';
import AddedRequiredBogoProducts from './AddedRequiredBogoProducts';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBogoRequiredProductsInCart } from 'src/redux/actions';
import { RootState } from 'src/redux/reducers';
import { IS_DESKTOP } from 'src/utils/checkClientDeviceType';
import RequiredBogoProductsDrawer from '../RequiredBogoProductsDrawer';
import { FullPageLoader } from 'src/components/FullPageLoader/FullPageLoader';
import { OFFER_PAGE_PARAMS } from '../../constants';
import { getUrlParams } from 'src/utils/getUrlParams';

const OfferPageHeader = ({ offerDetails, isReward = false }) => {
  const cartData = useSelector((state: RootState) => state.cartReducer);
  const [bogoRequiredProducts, setBogoRequiredProducts] = useState([]);
  const [showMoreProducts, setShowMoreProducts] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const { promo_id } = getUrlParams([OFFER_PAGE_PARAMS.PROMO_ID]) as any;
    if (isReward && cartData?.items?.length) {
      getRequiredProdutsInCart(+promo_id);
    }
  }, [isReward, cartData]);

  function getRequiredProdutsInCart(promoId) {
    const payload = {
      promo_id: promoId,
      cart: cartData,
    };

    dispatch(
      getBogoRequiredProductsInCart(payload, (products) =>
        setBogoRequiredProducts(products)
      )
    );
  }

  return (
    <>
      <div className="tw-mx-auto tw-flex tw-flex-col tw-gap-[40px] tw-px-[16px] md:tw-w-[1000px] md:tw-gap-[64px]">
        {isReward && !!bogoRequiredProducts?.length && (
          <AddedRequiredBogoProducts
            imageUrl={bogoRequiredProducts[0]?.image_url}
            name={bogoRequiredProducts[0]?.name}
            quantity={bogoRequiredProducts[0]?.quantity}
            totalProducts={bogoRequiredProducts?.length}
            setShowMoreProducts={setShowMoreProducts}
          />
        )}
        <div className="tw-flex tw-flex-col tw-gap-[4px] tw-text-center md:tw-gap-[14px]">
          <div className="tw-flex tw-justify-center tw-gap-[12px] tw-text-[12px]/[20px] md:tw-text-[14px]/[20px]">
            <span className="tw-flex tw-items-center tw-gap-[4px] tw-font-normal md:tw-font-semibold">
              {!IS_DESKTOP && <OfferIcon height={10} width={10} />}Exclusive Offer
            </span>
            {IS_DESKTOP && (
              <span className="tw-flex tw-items-center tw-gap-[6px]">
                <OfferIcon height={14} width={14} />
                {offerDetails?.heading}
              </span>
            )}
          </div>
          <div className="tw-text-[21px]/[28px] tw-font-semibold md:tw-text-[36px]/[50px]">
            {offerDetails?.subHeading}
          </div>
        </div>
      </div>
      <FullPageLoader />
      <RequiredBogoProductsDrawer
        show={showMoreProducts}
        onClose={() => setShowMoreProducts(false)}
        products={bogoRequiredProducts}
        offerDetails={offerDetails}
      />
    </>
  );
};

export default OfferPageHeader;
